// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpExitIntentModal-cls1_wi1","cls2":"LoswpExitIntentModal-cls2_7pi LoswpExitIntentModal-cls1_wi1"};